import React from 'react';
import { Button, Space, Typography } from 'antd';
import { ErrorBoundary } from 'react-error-boundary';
import { Icon502 } from '../../assets/NomIcon';

const { Title, Text } = Typography;

const CHUNK_ERROR_REGEX = /ChunkLoadError|Loading chunk .* failed|Loading CSS chunk/i;

const FallbackComponent = ({ error, componentStack, resetErrorBoundary }) => {
  const isChunkError = CHUNK_ERROR_REGEX.test(
    `${error?.name} ${error?.message}`,
  );

  if (isChunkError) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          padding: '40px',
          color: 'var(--midnight-sky, #16151D)',
        }}
      >
        <Space direction="vertical" size={8} style={{ marginBottom: '32px' }}>
          <Title
            level={2}
            style={{
              margin: 0,
              color: 'var(--midnight-sky, #16151D)',
              fontFamily: '"Just Sans", sans-serif',
            }}
          >
            A new version of the app is available.
          </Title>
        </Space>
        <Button
          type="primary"
          size="large"
          onClick={() => {
            window.sessionStorage.removeItem('chunk-reload-attempted');
            window.location.reload();
          }}
          style={{
            background: 'var(--electric-blue, #0055FF)',
            borderColor: 'var(--electric-blue, #0055FF)',
            fontFamily: '"Just Sans", sans-serif',
          }}
        >
          Reload
        </Button>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        padding: '40px',
        color: 'var(--midnight-sky, #16151D)',
      }}
    >
      <Icon502 style={{ fontSize: '252px', marginBottom: '24px' }} />
      <Space direction="vertical" size={8} style={{ marginBottom: '32px' }}>
        <Title
          level={2}
          style={{
            margin: 0,
            color: 'var(--midnight-sky, #16151D)',
            fontFamily: '"Just Sans", sans-serif',
          }}
        >
          Something Went Wrong
        </Title>
        <Text
          style={{
            fontSize: '16px',
            color: 'var(--midnight-sky, #16151D)',
            opacity: 0.7,
          }}
        >
          An unexpected error occurred. Please contact{' '}
          <a
            href="mailto:support@nomnomdata.com"
            style={{ color: 'var(--electric-blue, #0055FF)' }}
          >
            support@nomnomdata.com
          </a>
        </Text>
      </Space>
      <Button
        type="primary"
        size="large"
        onClick={resetErrorBoundary}
        style={{
          marginBottom: '24px',
          background: 'var(--electric-blue, #0055FF)',
          borderColor: 'var(--electric-blue, #0055FF)',
          fontFamily: '"Just Sans", sans-serif',
        }}
      >
        Try Again
      </Button>
      <details
        style={{
          cursor: 'pointer',
          maxWidth: '600px',
          textAlign: 'left',
          opacity: 0.6,
        }}
      >
        <summary style={{ userSelect: 'none', fontSize: '13px' }}>
          Technical details
        </summary>
        <pre
          style={{ whiteSpace: 'pre-wrap', fontSize: '12px', marginTop: '8px' }}
        >
          {error?.toString()}
          {componentStack}
        </pre>
      </details>
    </div>
  );
};

const handleError = (error, componentStack) => {
  // callApi('/nominode/ui-logs', 'PUT', {
  //   error: error.toString(),
  //   componentStack,
  //   requestUrl: window.location.href,
  // }).catch((err) => console.error(err));
};

export default (props) => {
  const { children } = props;
  return (
    <ErrorBoundary FallbackComponent={FallbackComponent} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
};
